import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
const controller = rpcController("BitacoraRAD");
import { cacheResource, bindResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";
import { BitacoraRADStatusDto } from 'app/models/requireme';

type Entity = models.BitacoraRAD;
type EntityDto = models.BitacoraRADDto;

export const BitacoraRAD = cacheResource({

    /**Obtiene todas las entidades filtradas por la zona */
    Query: async (filtro: models.BitacoraRADFiltro): Promise<EntityDto[]> => await controller('Query', {}, filtro),

    /**Obtiene una entidad*/
    Get: async (id: number): Promise<EntityDto> => await controller('Get', { id }),

    /**Agrega una entidad */
    Add: async (entity: Entity): Promise<number> => await controller('Add', {}, entity),

    /**
     * Actualiza la entidad
     * @param entity 
     */
    CambiarStatus:
        async (id: number, status: models.StatusBitacoraRad, observaciones: string): Promise<void> => await controller('CambiarStatus', { id, status, observaciones }),

    /**
     * Borra un ticket
     * @param id 
     */
    Delete: async (id: number): Promise<void> => await controller('Delete', { id }),

    /**Obtiene los status de una bitacora de RAD */
    QueryStatus: async (id: number): Promise<BitacoraRADStatusDto[]> => await controller("QueryStatus", { id }),

    /**Obtiene el reporte de eficiencia */
    GetReporte: async (min: Date, max: Date): Promise<string> => await controller("GetReporte", { min, max }),
}, {
        Query: true,
        QueryStatus: true,
        Get: true,
    }, {
        Add: true,
        CambiarStatus: true,
        Delete: true
    });


// WEBPACK FOOTER //
// ./app/resources/items/bitacoraRAD.ts